import { Fragment, useEffect, useState } from "react";
import "./CampaignSEOSprintScreen.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
    CreateSeoSprintContentCSV,
    CreateSeoSprintFacebookPostsCSV,
    CreateSeoSprintImagesCSV,
    CreateSeoSprintReportCSV,
    CreateSeoSprintVideosCSV,
    CreateSeoSprintYouTubeVideosCSV,
    DeleteCampaignFileByUrl,
    DeleteSeoSprintYouTubeFiles,
    GetCampaign,
    GetCampaignDefaultSettings,
    GetSeoSprintCSVFiles,
    GetCampaignSeoSprintHistoryList,
    GetSeoSprintImagesByPrompt,
    GetSeoSprintImagesSubjects,
    UpdateCampaign,
    UploadCampaignFiles,
    UploadSeoSprintFiles,
    UploadSeoSprintContentOnWPSite,
} from "../../../Services";
import PageHeadline from "../../../components/pageHeadline/PageHeadline";
import CampaignButtonsContainer from "../campaignButtonsContainer/CampaignButtonsContainer";
import CampaignTabs from "../../../components/campaignTabs/CampaignTabs";
import Spinner from "../../../components/spinner/Spinner";
import { toast } from "react-toastify";
import { useStateValue } from "../../../StateProvider";
import ModalDialog from "../../../components/modalDialog/ModalDialog";
import ModalDialogContent from "../../../components/modalDialog/modalDialogContent/ModalDialogContent";
import ModalDialogButtons from "../../../components/modalDialog/modalDialogButtons/ModalDialogButtons";
import FileUpload from "../../../components/fileUpload/FileUpload";
import { DateTimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import Moment from "react-moment";
import moment from "moment";
import { convertImageDataToFile, copyToClipboard, createGuid } from "../../../utils/Common";
import AIImageQulaitySelector from "../../../components/aiImageQulaitySelector/AIImageQulaitySelector";
import ImagePreviewModal from "../../../components/imagePreviewModal/ImagePreviewModal";
import CampaignSEOSprintSelectImageDialog from "./CampaignSEOSprintSelectImageDialog";
import GbpPostingForm from "./GbpPostingForm";

const CampaignSEOSprintScreen = () => {
    const [{ host, user }, dispatch] = useStateValue();
    const { campaignId } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [isSavingSettings, setIsSavingSettings] = useState(false);
    const [isCreatingContentCsv, setIsCreatingContentCsv] = useState(false);
    const [isCreatingGbpCsv, setIsCreatingGbpCsv] = useState(false);
    const [isCreatingFacebookCsv, setIsCreatingFacebookCsv] = useState(false);
    const [isCreatingVideosCsv, setIsCreatingVideosCsv] = useState(false);
    const [isCreatingYouTubeCsv, setIsCreatingYouTubeCsv] = useState(false);
    const [isCreatingReportCsv, setIsCreatingReportCsv] = useState(false);
    const [isUploadingFiles, setIsUploadingFiles] = useState(false);
    const [isGettingImages, setIsGettingImages] = useState(false);
    const [isSavingSelectedImages, setIsSavingSelectedImages] = useState(false);
    const [isSavingImageSettings, setIsSavingImageSettings] = useState(false);
    const [isCreatingImagesCsv, setIsCreatingImagesCsv] = useState(false);
    const [isDeletingYouTubeCsv, setIsDeletingYouTubeCsv] = useState(false);
    const [isUploadingContentOnWPSite, setIsUploadingContentOnWPSite] = useState(false);
    const [campaign, setCampaign] = useState();
    const [csvFiles, setCsvFiles] = useState();
    const [seoSprintHistoryList, setSeoSprintHistoryList] = useState([]);
    const [formData, setFormData] = useState({});
    const [showImagePreviewDialog, setShowImagePreviewDialog] = useState(false);
    const [imagePreviewSrc, setImagePreviewSrc] = useState();
    const [settingsData, setSettingsData] = useState();
    const [seedImagesData, setSeedImagesData] = useState({ images: [], groups: [] });
    const [showSelectImageDialog, setShowSelectImageDialog] = useState(false);
    const [showSeedImageGroupDialog, setShowSeedImageGroupDialog] = useState(false);
    const [seedImageGroupName, setSeedImageGroupName] = useState();
    const [editedSeedImageGroupId, setEditedSeedImageGroupId] = useState();
    const [showCopiedMessage, setShowCopiedMessage] = useState(false);
    const [facebookScheduleDate, setFacebookScheduleDate] = useState(moment());
    const [facebookExcludeWeekends, setFacebookExcludeWeekends] = useState(true);
    const [facebookServicesData, setFacebookServicesData] = useState([]);
    const [youTubeScheduleDate, setYouTubeScheduleDate] = useState(moment());
    const [youTubeSchedulingOn, setYouTubeSchedulingOn] = useState(true);
    const [youTubeExcludeWeekends, setYouTubeExcludeWeekends] = useState(true);
    const [youTubePostsPerDay, setYouTubePostsPerDay] = useState();
    const [videosType, setVideosType] = useState("locations");
    const [videosLocations, setVideosLocations] = useState();
    const [videosServicesData, setVideosServicesData] = useState([]);
    const [seedImagesCommand, setSeedImagesCommand] = useState();
    const [seedImagesSubjects, setSeedImagesSubjects] = useState();
    const [seedImagesInclusions, setSeedImagesInclusions] = useState();
    const [seedImagesExclusions, setSeedImagesExclusions] = useState();
    const [numberOfImages, setNumberOfImages] = useState();
    const [imageResponse, setImageResponse] = useState();
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectedImageGroup, setSelectedImageGroup] = useState();
    const [imageQuality, setImageQuality] = useState("high");
    const [uploadedImages, setUploadedImages] = useState([]);
    const [selectedImageGroupsForVideos, setSelectedImageGroupsForVideos] = useState([]);
    const [totalImagesCountForSelectedGroups, setTotalImagesCountForSelectedGroups] = useState(0);
    const [totalLocationsCount, setTotalLocationsCount] = useState(0);
    const [isEditingImagesSubjectsCommand, setIsEditingImagesSubjectsCommand] = useState(false);
    const [imagesSubjectsCommand, setImagesSubjectsCommand] = useState();
    const [isGettingImagesSubjects, setIsGettingImagesSubjects] = useState(false);
    const [imageSelectDialogArg, setImageSelectDialogArg] = useState();
    const navigate = useNavigate();
    const defaultAIModel = "gpt-4o-mini";
    const seoSprintTabs = [
        { label: "Settings", slug: "settings" },
        { label: "Images", slug: "images" },
        { label: "On Site Content", slug: "onSiteContent" },
        { label: "GBP Posts", slug: "gbpPosts" },
        { label: "Facebook Posts", slug: "facebookPosts" },
        { label: "Generate Videos", slug: "generateVideos" },
        { label: "YouTube Videos", slug: "youTubeVideos" },
        { label: "Report", slug: "report" },
        { label: "Placeholders", slug: "placeholders" },
    ];
    const placeholders = [
        { label: "Primary Services", value: "{PRIMARY SERVICES}" },
        { label: "Primary Service Area", value: "{PRIMARY SERVICE AREA}" },
        { label: "List Of Services", value: "{SERVICES LIST}" },
        { label: "List Of Locations", value: "{LOCATIONS LIST}" },
        { label: "Single Service", value: "{SERVICE}" },
        { label: "Single Location", value: "{LOCATION}" },
        { label: "Business Name", value: "{BUSINESS NAME}" },
        { label: "Business Address", value: "{BUSINESS ADDRESS}" },
        { label: "Business Phone", value: "{BUSINESS PHONE}" },
        { label: "Business Google Profile Url", value: "{BUSINESS GOOGLE PROFILE URL}" },
        { label: "Video Length", value: "{VIDEO LENGTH}" },
        { label: "Random Service Item", value: "{SERVICE ITEM}" },
        { label: "Random Location Item", value: "{LOCATION ITEM}" },
        { label: "Random Image Item", value: "{IMAGE ITEM}" },
        { label: "Images Subject", value: "{IMAGE SUBJECT}" },
    ];
    const apiUrl =
        host.indexOf("localhost") > -1 || host.indexOf("dev.") > -1 || host.indexOf("dev-") > -1
            ? "dev-api.gbpboost.com"
            : "gbpapi.gbpboost.com";

    useEffect(() => {
        if (campaignId) {
            getDefaultSettings();
            getCampaign();
            getCSVFiles();
            getSeoSprintHistoryList();
            moment.tz.setDefault("America/New_York");
        }
    }, [campaignId]);

    const getCampaign = async () => {
        const response = await GetCampaign(campaignId);

        if (response) {
            document.title = "SEO Sprint - " + response.name;

            setCampaign(response);
            setFormData(response);

            if (response.seoSprintListOfLocations) {
                setTotalLocationsCount(response.seoSprintListOfLocations.split("\n").length);
            }
        }
    };

    const getDefaultSettings = async () => {
        let response = await GetCampaignDefaultSettings();

        if (response && response.data) {
            setSettingsData(response.data);
        }
    };

    useEffect(() => {
        if (campaign && settingsData) {
            let tempImagesCommand, tempImagesSubjects, tempImagesSubjectsCommand, tempImagesInclusions, tempImagesExclusions;

            if (campaign.seoSprintSeedImagesJson) {
                let tempImagesJson = JSON.parse(campaign.seoSprintSeedImagesJson);

                if (tempImagesJson) {
                    setSeedImagesData(tempImagesJson);
                    tempImagesCommand = tempImagesJson.command;
                    tempImagesSubjects = tempImagesJson.subjects;
                    tempImagesSubjectsCommand = tempImagesJson.subjectsCommand;
                    tempImagesInclusions = tempImagesJson.inclusions;
                    tempImagesExclusions = tempImagesJson.exclusions;

                    if (tempImagesJson.groups && tempImagesJson.groups.length) {
                        setSelectedImageGroup(tempImagesJson.groups[0].id);
                    }
                }
            }

            //load from default settings if values are empty
            if (!tempImagesCommand) {
                tempImagesCommand = settingsData.seoSprintSeedImagesCommand;
            }
            if (!tempImagesSubjects) {
                tempImagesSubjects = settingsData.seoSprintSeedImagesSubjects;
            }
            if (!tempImagesSubjectsCommand) {
                tempImagesSubjectsCommand = settingsData.seoSprintSeedImagesSubjectsCommand;
            }
            if (!tempImagesInclusions) {
                tempImagesInclusions = settingsData.seoSprintSeedImagesInclusions;
            }
            if (!tempImagesExclusions) {
                tempImagesExclusions = settingsData.seoSprintSeedImagesExclusions;
            }

            setSeedImagesCommand(tempImagesCommand);
            setSeedImagesSubjects(tempImagesSubjects);
            setImagesSubjectsCommand(tempImagesSubjectsCommand);
            setSeedImagesInclusions(tempImagesInclusions);
            setSeedImagesExclusions(tempImagesExclusions);
        }
    }, [campaign, settingsData]);

    const getCSVFiles = async () => {
        const response = await GetSeoSprintCSVFiles(campaignId);

        if (response.success) {
            setCsvFiles(response.data);
        }
    };

    const getSeoSprintHistoryList = async () => {
        const response = await GetCampaignSeoSprintHistoryList(campaignId);

        if (response && response.length) {
            setSeoSprintHistoryList(response);
        }
    };

    const handleChange = async (e) => {
        let type = e.target.type;
        let value = type === "checkbox" ? e.target.checked : e.target.value;

        setFormData({
            ...formData,
            [e.target.name]: value,
        });
    };

    const saveCampaignImageDataJson = async (tempSeedImagesData) => {
        //save to db
        let tempCampaign = { ...campaign, seoSprintSeedImagesJson: JSON.stringify(tempSeedImagesData) };

        const response = await UpdateCampaign(campaignId, tempCampaign);

        if (response.success) {
            //toast.success('Settings saved.');
        }
    };

    const handleSaveSettings = async () => {
        if (!validateSettingsRequiredFields()) {
            return;
        }

        setIsSavingSettings(true);

        let tempCampaign = { ...campaign, ...formData };

        const response = await UpdateCampaign(campaignId, tempCampaign);

        if (response.success) {
            toast.success("Settings saved.");
            setCampaign(tempCampaign);
        }

        setIsSavingSettings(false);
    };

    const validateSettingsRequiredFields = () => {
        return document.querySelector("form").reportValidity();
    };

    const saveCampaignWPSiteUrl = async () => {
        if (
            formData.seoSprintWPSiteUrl &&
            !formData.seoSprintWPSiteUrl.startsWith("https://") &&
            !formData.seoSprintWPSiteUrl.startsWith("http://")
        ) {
            toast.error("Url must start with https://");
            return;
        }

        setIsSavingSettings(true);

        let wpSiteUrl = formData.seoSprintWPSiteUrl;
        if (wpSiteUrl && wpSiteUrl.endsWith("/")) {
            wpSiteUrl = wpSiteUrl.slice(0, -1);
        }

        let tempCampaign = { ...campaign, seoSprintWPSiteUrl: wpSiteUrl };

        const response = await UpdateCampaign(campaignId, tempCampaign);

        if (response.success) {
            toast.success("Saved successfully.");
        }

        setIsSavingSettings(false);
    };

    const uploadContentOnWPSite = async () => {
        if (
            !formData.seoSprintWPSiteUrl &&
            !formData.seoSprintWPSiteUrl.startsWith("https://") &&
            !formData.seoSprintWPSiteUrl.startsWith("http://")
        ) {
            toast.error("Invalid WordPress site url.");
            return;
        }

        setIsUploadingContentOnWPSite(true);

        let data = {
            userId: user.id,
            wpSiteUrl: formData.seoSprintWPSiteUrl,
        };

        const response = await UploadSeoSprintContentOnWPSite(campaignId, data);

        if (response.IsSuccessful === false && response.Message) {
            toast.error("Upload failed. " + (response.Message.message ? `Reason: ${response.Message.message}` : "") + ".");
        } else if (response.success === true) {
            toast.success("Upload completed successfully.");
        } else if (response.success === false) {
            toast.error(response.message);
        }

        setIsUploadingContentOnWPSite(false);
    };

    const handleGenerateContentCsvFiles = async () => {
        if (!validateSettingsRequiredFields()) {
            toast.error("Please fill out required fields on Settings tab first.");
            return;
        }

        setIsCreatingContentCsv(true);

        let data = {
            campaignId: campaignId,
            aiModel: settingsData.seoSprintAIModel,
        };

        //create csv files
        const responseCSV = await CreateSeoSprintContentCSV(campaignId, data);
        if (responseCSV.success) {
            await getCSVFiles();
        }

        setIsCreatingContentCsv(false);
    };

    const handleGenerateVideosCsvFiles = async () => {
        if (!validateSettingsRequiredFields()) {
            toast.error("Please fill out required fields on Settings tab first.");
            return;
        }

        let totalLocationsSelected = videosLocations ? videosLocations.length : 0;

        if (
            (!totalLocationsSelected || totalLocationsSelected === 0) &&
            (!videosServicesData || videosServicesData.length === 0 || videosServicesData.filter((x) => x.checked).length === 0)
        ) {
            toast.error("No any location or service selected.");
            return;
        }

        if (totalLocationsSelected > 0 && totalImagesCountForSelectedGroups < totalLocationsSelected) {
            toast.error("Number of images is less than number of locations.");
            return;
        }

        let selectedVideosServicesData = videosServicesData.filter((x) => x.checked);

        if (selectedVideosServicesData && selectedVideosServicesData.length > 0) {
            //check if every service has image groups applied
            for (let i = 0; i < selectedVideosServicesData.length; i++) {
                if (!selectedVideosServicesData[i].imageGroups || selectedVideosServicesData[i].imageGroups.length === 0) {
                    toast.error("No image groups selected for all services.");
                    return;
                }
            }
        }

        setIsCreatingVideosCsv(true);

        let data = {
            campaignId: campaignId,
            locations: videosLocations,
            locationsImageGroups: selectedImageGroupsForVideos,
            services: videosServicesData.filter((x) => x.checked),
            aiModel: settingsData.seoSprintAIModel,
        };

        //create csv files
        const responseCSV = await CreateSeoSprintVideosCSV(campaignId, data);
        if (responseCSV.success) {
            await getCSVFiles();
        }

        setIsCreatingVideosCsv(false);
    };

    const handleGenerateFacebookPostsCsvFiles = async () => {
        if (!validateSettingsRequiredFields()) {
            toast.error("Please fill out required fields on Settings tab first.");
            return;
        }

        if (!facebookServicesData || facebookServicesData.length === 0) {
            toast.error("You have to select at least one service.");
            return;
        }

        let noServicesChecked = facebookServicesData.some((x) => !x.checked || x.checked === false);
        let missingImage = facebookServicesData.some((x) => !x.imageUrl || x.imageUrl === "");

        if (noServicesChecked) {
            toast.error("You have to select at least one service.");
            return;
        }

        if (missingImage) {
            toast.error("You have to select an image for each service.");
            return;
        }

        if (!facebookScheduleDate || facebookScheduleDate === "") {
            toast.error("Schedule date is required.");
            return;
        }

        setIsCreatingFacebookCsv(true);

        let data = {
            campaignId: campaignId,
            serviceImages: facebookServicesData,
            scheduleDate: moment.utc(facebookScheduleDate),
            excludeWeekends: facebookExcludeWeekends,
            aiModel: settingsData.seoSprintAIModel,
        };

        //create csv files
        const responseCSV = await CreateSeoSprintFacebookPostsCSV(campaignId, data);
        if (responseCSV.success) {
            await getCSVFiles();
        }

        setIsCreatingFacebookCsv(false);
    };

    const handleGenerateYouTubeVideosCsvFiles = async () => {
        if (!validateSettingsRequiredFields()) {
            toast.error("Please fill out required fields on Settings tab first.");
            return;
        }

        if (!youTubePostsPerDay || youTubePostsPerDay === "") {
            toast.error("Posts per day is required.");
            return;
        }

        setIsCreatingYouTubeCsv(true);

        let data = {
            campaignId: campaignId,
            postsPerDay: youTubePostsPerDay,
            schedulingOn: youTubeSchedulingOn,
            scheduleDate: youTubeSchedulingOn ? moment.utc(youTubeScheduleDate) : null,
            excludeWeekends: youTubeExcludeWeekends,
            aiModel: settingsData.seoSprintAIModel,
        };

        //create csv files
        const responseCSV = await CreateSeoSprintYouTubeVideosCSV(campaignId, data);
        if (responseCSV.success) {
            await getCSVFiles();
        }

        setIsCreatingYouTubeCsv(false);
    };

    const handleGenerateReportCsvFiles = async () => {
        if (!validateSettingsRequiredFields()) {
            toast.error("Please fill out required fields on Settings tab first.");
            return;
        }

        setIsCreatingReportCsv(true);

        //create csv files
        const responseCSV = await CreateSeoSprintReportCSV(campaignId);
        if (responseCSV.success) {
            await getCSVFiles();
        }

        setIsCreatingReportCsv(false);
    };

    const handleNext = async () => {
        navigate(`/setup/${campaignId}/notes`);
    };

    const getImagesByPrompt = async () => {
        if (!seedImagesCommand || seedImagesCommand === "") {
            toast.error("Command is required.");
            return;
        }

        if (!imagesSubjectsCommand || imagesSubjectsCommand === "") {
            toast.error("Subjects are required.");
            return;
        }

        if (!numberOfImages || numberOfImages === "") {
            toast.error("Number of images is required.");
            return;
        }

        setIsGettingImages(true);

        let data = {
            campaignId: campaignId,
            aiModel: "gpt-image-1",
            seedImagesCommand: seedImagesCommand,
            imagesCommandSubjects: seedImagesSubjects,
            numberOfImages: numberOfImages,
            quality: imageQuality,
            apiMethodType: "new",
        };

        const response = await GetSeoSprintImagesByPrompt(campaignId, data);
        if (response.success) {
            if (response.data) {
                let tempImageResponse = [];
                let tempSelectedImages = [];

                response.data.forEach((imageBase64String) => {
                    let imageItem = { id: createGuid(8), data: "data:image/png;base64," + imageBase64String };

                    tempImageResponse.push(imageItem);
                    tempSelectedImages.push(imageItem);
                });

                setImageResponse(tempImageResponse);
                setSelectedImages(tempSelectedImages);

                //reload campaign details because some images data changed in backend
                await getCampaign();

                setIsGettingImages(false);
            } else {
                console.log("Error: " + (response.message || ""));
                setIsGettingImages(false);
            }
        } else {
            console.log("Error: " + (response.message || ""));
            setIsGettingImages(false);
        }
    };

    const handleSelectImage = async (e) => {
        const { name, checked } = e.target;

        let tempSelectedImages = [...selectedImages];

        let imageId = name.replace("chkImg_", "");

        if (checked) {
            let existingImage = tempSelectedImages.find((x) => x.id === imageId);

            if (!existingImage) {
                let img = document.querySelector('.image-wrapper img[id="img_' + imageId + '"]');

                if (img && img.src) {
                    tempSelectedImages.push({ id: imageId, data: img.src });
                }
            }
        } else {
            tempSelectedImages = tempSelectedImages.filter((x) => x.id !== imageId);
        }

        setSelectedImages(tempSelectedImages);
    };

    const saveSelectedImages = async () => {
        if (!selectedImages || selectedImages.length === 0) {
            toast.error("There is no selected images.");
            return;
        }

        if (!selectedImageGroup || selectedImageGroup === "") {
            toast.error("Image group is required.");
            return;
        }

        setIsSavingSelectedImages(true);

        await uploadImages(selectedImages);
    };

    const uploadImages = async (images) => {
        let imageUrls = [];

        for (const image of images) {
            if (image.data) {
                let imageName = `img_${createGuid(8)}`;
                let imageFile;

                var data = new FormData();

                imageFile = await convertImageDataToFile(image.data, imageName);

                if (imageFile) {
                    data.append("Files", imageFile);
                    data.append("Target", `SEOSprint|${imageName}`);

                    const response = await UploadCampaignFiles(campaignId, data);

                    if (response !== undefined && response.data && response.data.length > 0) {
                        imageUrls.push(response.data[0].fullCdnUrl);
                    }
                }
            }
        }

        setUploadedImages(imageUrls);
    };

    useEffect(() => {
        async function saveImageData() {
            try {
                if (isSavingSelectedImages) {
                    if (uploadedImages && selectedImages && selectedImages.length > 0 && uploadedImages.length === selectedImages.length) {
                        //save json changes into db
                        let tempImagesArray = [...seedImagesData.images];

                        if (!tempImagesArray) {
                            tempImagesArray = [];
                        }

                        uploadedImages.forEach((imageUrl) => {
                            tempImagesArray.push({
                                id: createGuid(),
                                url: imageUrl,
                                groups: [selectedImageGroup],
                            });
                        });

                        let tempImagesData = { ...seedImagesData, images: tempImagesArray };

                        //save to db
                        let tempCampaign = { ...campaign, seoSprintSeedImagesJson: JSON.stringify(tempImagesData) };

                        const response = await UpdateCampaign(campaignId, tempCampaign);

                        if (response.success) {
                            //toast.success('Settings saved.');
                            setSeedImagesData(tempImagesData);

                            setImageResponse([]);
                            setUploadedImages([]);
                            setSelectedImages([]);
                        }

                        setIsSavingSelectedImages(false);
                    }
                }
            } catch (e) {
                console.error(e);
                setIsSavingSelectedImages(false);
            }
        }
        saveImageData();
    }, [isSavingSelectedImages, uploadedImages]);

    const saveImagesData = async () => {
        setIsSavingImageSettings(true);

        let tempImagesData = {
            ...seedImagesData,
            command: seedImagesCommand,
            subjectsCommand: imagesSubjectsCommand,
            subjects: seedImagesSubjects,
            inclusions: seedImagesInclusions,
            exclusions: seedImagesExclusions,
        };

        //save to db
        let tempCampaign = { ...campaign, seoSprintSeedImagesJson: JSON.stringify(tempImagesData) };

        const response = await UpdateCampaign(campaignId, tempCampaign);

        if (response.success) {
            toast.success("Settings saved.");
        }

        setIsSavingImageSettings(false);
    };

    const toggleImagePreviewDialog = async (e, imageSrc) => {
        setShowImagePreviewDialog(!showImagePreviewDialog);

        if (!showImagePreviewDialog) {
            setImagePreviewSrc(imageSrc);
        } else {
            setImagePreviewSrc();
        }

        if (e) e.preventDefault();
    };

    const deleteSeedImage = async (e, url) => {
        e.preventDefault();

        //delete image from database
        if (window.confirm("Are you sure that you want to delete this image?")) {
            let fileName = new URL(url).pathname.split("/").pop();
            let fileNameWOExt = fileName.substring(0, fileName.lastIndexOf(".")) || fileName;

            let data = {
                campaignId: campaignId,
                url: url,
                target: `SEOSprint|${fileNameWOExt}`,
            };

            const deleteResponse = await DeleteCampaignFileByUrl(campaignId, data);

            if (deleteResponse.success) {
                //delete image from json column
                if (seedImagesData && seedImagesData.images) {
                    let tempImagesArray = [...seedImagesData.images];

                    tempImagesArray = tempImagesArray.filter((x) => x.url !== url);

                    let tempImagesData = { ...seedImagesData, images: tempImagesArray };

                    //save to db
                    let tempCampaign = { ...campaign, seoSprintSeedImagesJson: JSON.stringify(tempImagesData) };

                    const updateResponse = await UpdateCampaign(campaignId, tempCampaign);

                    if (updateResponse.success) {
                        setSeedImagesData(tempImagesData);
                    }
                }
            }
        }
    };

    const createImagesCsv = async () => {
        setIsCreatingImagesCsv(true);

        const response = await CreateSeoSprintImagesCSV(campaignId);

        if (response.success) {
            getCSVFiles();
        }

        setIsCreatingImagesCsv(false);
    };

    const getImagesSubjects = async () => {
        setIsGettingImagesSubjects(true);

        let data = {
            id: campaign.id,
            instructions: imagesSubjectsCommand,
            aiModel: defaultAIModel,
        };

        const response = await GetSeoSprintImagesSubjects(campaignId, data);

        if (response.success && response.data) {
            let items = [];

            //remove numbers from response items
            for (let i = 0; i < response.data.length; i++) {
                let item = response.data[i];

                item = item.replace(/\d\.\s+|[a-z]\)\s+|•\s+|[A-Z]\.\s+|[IVX]+\.\s+/g, ""); //remove bullets
                item = item.replace(/^-+/, ""); //remove hyphen
                item = item.replace(/^[0-9]+/, ""); //remove starting number
                item = item.trim();

                //add to list if it doesn't exist
                let itemFound = items.find((x) => x.toString().toLowerCase() === item.toString().toLowerCase());

                if (!itemFound || itemFound === null) {
                    items.push(item);
                }
            }

            setSeedImagesSubjects(items.join("\n"));
        }

        setIsGettingImagesSubjects(false);
    };

    const toggleSelectImageDialog = (arg) => {
        setShowSelectImageDialog(!showSelectImageDialog);

        setImageSelectDialogArg(arg);

        if (showSelectImageDialog) {
            setImageSelectDialogArg();
        } else {
        }
    };

    const toggleSeedImageGroupDialog = (id) => {
        let tempImageGroupsData = [...seedImagesData.groups];

        if (id) {
            setEditedSeedImageGroupId(id);
            let existingGroup = tempImageGroupsData.find((x) => x.id === id);

            if (existingGroup) {
                setSeedImageGroupName(existingGroup.name);
            }
        } else {
            setEditedSeedImageGroupId();
        }

        setShowSeedImageGroupDialog(!showSeedImageGroupDialog);
    };

    const saveSeedImageGroup = async () => {
        if (!seedImageGroupName || seedImageGroupName === "") {
            toast.error("Group name is required.");
            return;
        }

        let tempImageGroupsData = [...seedImagesData.groups];

        if (editedSeedImageGroupId) {
            //edit
            let existingGroup = tempImageGroupsData.find((x) => x.id === editedSeedImageGroupId);

            if (existingGroup) {
                existingGroup.name = seedImageGroupName;
            }
        } else {
            //new group
            tempImageGroupsData.push({ id: createGuid(), name: seedImageGroupName });
        }

        let tempSeedImagesData = { ...seedImagesData, groups: tempImageGroupsData };

        await saveCampaignImageDataJson(tempSeedImagesData);

        setSeedImagesData(tempSeedImagesData);
        setShowSeedImageGroupDialog(!showSeedImageGroupDialog);
        setSeedImageGroupName();
    };

    const deleteSeedImageGroup = async (id) => {
        if (window.confirm("Are you sure that you want to delete this seed image group?")) {
            let tempImageGroupsData = [...seedImagesData.groups];

            if (tempImageGroupsData) {
                tempImageGroupsData = tempImageGroupsData.filter((x) => x.id !== id);

                let tempSeedImagesData = { ...seedImagesData, groups: tempImageGroupsData };
                setSeedImagesData(tempSeedImagesData);

                await saveCampaignImageDataJson(tempSeedImagesData);
            }
        }
    };

    const getImagesNumberByGroup = (groupId) => {
        if (seedImagesData && seedImagesData.images && seedImagesData.images.length) {
            return seedImagesData.images.filter((x) => (x.groups ? x.groups.includes(groupId) : true)).length;
        }

        return 0;
    };

    const handleVideosLocationsChange = async (e) => {
        const { name, checked, value } = e.target;
        let tempVideosLocations = videosLocations ? [...videosLocations] : [];

        if (checked) {
            if (!tempVideosLocations.includes(value)) {
                tempVideosLocations.push(value);
            }
        } else {
            tempVideosLocations = tempVideosLocations.filter((x) => x !== value);
        }

        setVideosLocations(tempVideosLocations);
    };

    const handleVideosSelectedServiceChange = (e) => {
        const { checked, dataset } = e.target;

        let tempVideosServicesData = [...videosServicesData];

        let existingService = tempVideosServicesData.find((x) => x.service === dataset.service);

        if (existingService) {
            existingService.checked = checked;
        } else {
            tempVideosServicesData.push({ service: dataset.service, imageGroups: [], checked: checked });
        }

        setVideosServicesData(tempVideosServicesData);
    };

    const handleSelectAllVideosLocationsChange = async (e) => {
        const { checked } = e.target;
        let tempVideosLocations = [];

        if (checked) {
            if (formData.seoSprintListOfLocations) {
                tempVideosLocations = formData.seoSprintListOfLocations.split("\n");
            }
        }

        setVideosLocations(tempVideosLocations);
    };

    const handleSelectedImageGroupsForVideosChange = async (e) => {
        const { name, checked } = e.target;
        let tempImageGroups = [...selectedImageGroupsForVideos] || [];
        let groupId = name.replace("chkSeedImageGroup_", "");

        if (checked) {
            let existingGroup = seedImagesData.groups.find((x) => x.id === groupId);

            if (existingGroup) {
                tempImageGroups.push(existingGroup.id);
            }
        } else {
            tempImageGroups = tempImageGroups.filter((x) => x !== groupId);
        }

        setSelectedImageGroupsForVideos(tempImageGroups);

        //get total images count for all selected groups
        let tempTotalImagesSelected = 0;

        if (tempImageGroups && tempImageGroups.length)
            tempImageGroups.forEach((groupId) => {
                tempTotalImagesSelected += getImagesNumberByGroup(groupId);
            });

        setTotalImagesCountForSelectedGroups(tempTotalImagesSelected);
    };

    const handleSelectedImageGroupsForVideosServiceChange = async (e, service) => {
        const { name, checked } = e.target;
        let tempVideosServicesData = [...videosServicesData] || [];
        let serviceSlug = service.replaceAll(" ", "_");
        let groupId = name.replace("chkVideosServiceImageGroup_", "").replace(`_${serviceSlug}`, "");
        let currentService = tempVideosServicesData.find((x) => x.service === service);

        if (currentService) {
            if (!currentService.imageGroups) {
                currentService.imageGroups = [];
            }

            if (checked) {
                let existingGroup = seedImagesData.groups.find((x) => x.id === groupId);

                if (existingGroup) {
                    currentService.imageGroups.push(existingGroup.id);
                }
            } else {
                currentService.imageGroups = currentService.imageGroups.filter((x) => x !== groupId);
            }

            setVideosServicesData(tempVideosServicesData);
        }
    };

    const handleSelectAllVideosImageGroupsChange = async (e) => {
        const { checked } = e.target;
        let tempImageGroups = [];

        if (checked) {
            if (seedImagesData && seedImagesData.groups) {
                seedImagesData.groups.forEach((group) => {
                    tempImageGroups.push(group.id);
                });
            }
        }

        setSelectedImageGroupsForVideos(tempImageGroups);

        //get total images count for all selected groups
        let tempTotalImagesSelected = 0;

        if (tempImageGroups && tempImageGroups.length)
            tempImageGroups.forEach((groupId) => {
                tempTotalImagesSelected += getImagesNumberByGroup(groupId);
            });

        setTotalImagesCountForSelectedGroups(tempTotalImagesSelected);
    };

    const handleYouTubeVideosUpload = async (files) => {
        //upload files on server
        if (files !== undefined) {
            setIsUploadingFiles(true);

            var data = new FormData();

            for (var i = 0; i !== files.length; i++) {
                data.append("Files", files[i]);
            }

            data.append("Target", "YouTube");

            const response = await UploadSeoSprintFiles(campaignId, data);

            if (response !== undefined && response.data && response.data.length > 0) {
                await getCSVFiles();

                setIsUploadingFiles(false);
            } else {
                setIsUploadingFiles(false);
            }
        }
    };

    const handleFacebookImageUpload = async (files, type, service) => {
        //upload files on server
        if (files !== undefined) {
            let imageName = `img_${createGuid(8)}`;

            var data = new FormData();

            for (var i = 0; i !== files.length; i++) {
                data.append("Files", files[i]);
            }

            data.append("Target", `SEOSprint|${imageName}`);

            const response = await UploadCampaignFiles(campaignId, data);

            if (response !== undefined && response.data && response.data.length > 0) {
                let imageUrl = response.data[0].fullCdnUrl;

                if (seedImagesData && seedImagesData.images) {
                    //save image to db
                    let tempImagesArray = [...seedImagesData.images];

                    tempImagesArray.push({ id: createGuid(), url: imageUrl, groups: [] });

                    let tempImagesData = { ...seedImagesData, images: tempImagesArray };

                    let tempCampaign = { ...campaign, seoSprintSeedImagesJson: JSON.stringify(tempImagesData) };

                    const updateResponse = await UpdateCampaign(campaignId, tempCampaign);

                    if (updateResponse.success) {
                        setSeedImagesData(tempImagesData);
                    }

                    //update services array
                    let tempFacebookServicesData = [...facebookServicesData];

                    let existingService = tempFacebookServicesData.find((x) => x.service === service);

                    if (existingService) {
                        existingService.imageUrl = imageUrl;
                    } else {
                        tempFacebookServicesData.push({ service: service, imageUrl: imageUrl, checked: false });
                    }

                    setFacebookServicesData(tempFacebookServicesData);
                }
            }
        }
    };

    const handleFacebookSelectedServiceChange = (e) => {
        const { checked, name, dataset } = e.target;

        let tempFacebookServicesData = [...facebookServicesData];

        let existingService = tempFacebookServicesData.find((x) => x.service === dataset.service);

        if (existingService) {
            existingService.checked = checked;
        } else {
            tempFacebookServicesData.push({ service: dataset.service, imageUrl: "", checked: checked });
        }

        setFacebookServicesData(tempFacebookServicesData);
    };

    const handleSelectFacebookImage = (service, selectedImages) => {
        if (selectedImages && selectedImages.length) {
            let imageUrl = selectedImages[0];

            //update services array
            let tempFacebookServicesData = [...facebookServicesData];

            let existingService = tempFacebookServicesData.find((x) => x.service === service);

            if (existingService) {
                existingService.imageUrl = imageUrl;
            } else {
                tempFacebookServicesData.push({ service: service, imageUrl: imageUrl, checked: false });
            }

            toggleSelectImageDialog();
            setFacebookServicesData(tempFacebookServicesData);
        }
    };

    const handleDeleteYouTubeVideosFiles = async () => {
        setIsDeletingYouTubeCsv(true);

        let response = await DeleteSeoSprintYouTubeFiles(campaign.id);

        if (response) {
            await getCSVFiles();
        }

        setIsDeletingYouTubeCsv(false);
    };

    return (
        <div className="container-fluid campaign-main-container">
            <PageHeadline
                campaign={campaign}
                headline={`Campaign - ${campaign ? campaign.name : ""}`}
                linkText="Back To List"
                linkUrl="/campaigns/list"
            />

            <CampaignTabs />

            {isLoading && <Spinner />}

            {!isLoading && (
                <div className="campaign-form-container">
                    <ul className="nav nav-tabs" id="tabSeoSprint" role="tablist">
                        {seoSprintTabs.map((tab, index) => (
                            <li className="nav-item" role="presentation" key={tab.slug}>
                                <button
                                    className={`nav-link ${index === 0 ? "active" : ""}`}
                                    id={`${tab.slug}-tab`}
                                    data-bs-toggle="tab"
                                    data-bs-target={`#${tab.slug}-tab-pane`}
                                    type="button"
                                    role="tab"
                                    aria-controls={`${tab.slug}-tab-pane`}
                                    aria-selected={index === 0 ? "true" : "false"}
                                >
                                    {tab.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                    <div className="tab-content border seo-sprint-tab-content" id="tabSeoSprintContent">
                        {seoSprintTabs.map((tab, tabIndex) => (
                            <div
                                className={`tab-pane fade ${tabIndex === 0 ? "show active" : ""}`}
                                id={`${tab.slug}-tab-pane`}
                                key={tab.slug}
                                role="tabpanel"
                                aria-labelledby={`${tab.slug}-tab`}
                                tabIndex={tabIndex}
                            >
                                {tab.slug === "settings" && (
                                    <div className="p-3">
                                        <form className="text-start">
                                            <div className="row mb-3">
                                                <label htmlFor="seoSprintPrimaryServices" className="form-label col-2">
                                                    Primary Services:
                                                </label>
                                                <div className="col-4">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="seoSprintPrimaryServices"
                                                        value={formData.seoSprintPrimaryServices || ""}
                                                        onChange={handleChange}
                                                        required
                                                        disabled={isSavingSettings}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="seoSprintPrimaryServiceArea" className="form-label col-2">
                                                    Primary Service Area:
                                                </label>
                                                <div className="col-4">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="seoSprintPrimaryServiceArea"
                                                        value={formData.seoSprintPrimaryServiceArea || ""}
                                                        onChange={handleChange}
                                                        required
                                                        disabled={isSavingSettings}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="seoSprintListOfServices" className="form-label col-2">
                                                    List Of Services:
                                                </label>
                                                <div className="col-4">
                                                    <textarea
                                                        type="text"
                                                        className="form-control"
                                                        name="seoSprintListOfServices"
                                                        value={formData.seoSprintListOfServices || ""}
                                                        onChange={handleChange}
                                                        rows={5}
                                                        required
                                                        disabled={isSavingSettings}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="seoSprintListOfLocations" className="form-label col-2">
                                                    List Of Locations:
                                                </label>
                                                <div className="col-4">
                                                    <textarea
                                                        type="text"
                                                        className="form-control"
                                                        name="seoSprintListOfLocations"
                                                        value={formData.seoSprintListOfLocations || ""}
                                                        onChange={handleChange}
                                                        rows={5}
                                                        required
                                                        disabled={isSavingSettings}
                                                    />
                                                    <label className="form-label mt-0">
                                                        {formData.seoSprintListOfLocations && (
                                                            <Fragment>{`${
                                                                formData.seoSprintListOfLocations.split("\n").length
                                                            } locations`}</Fragment>
                                                        )}
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label htmlFor="ghlApiToken" className="form-label col-2">
                                                    GoHighLevel Api Key:
                                                </label>
                                                <div className="col-4">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="ghlApiToken"
                                                        value={formData.ghlApiToken || ""}
                                                        onChange={handleChange}
                                                        disabled={isSavingSettings}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-0">
                                                <div className="col-6">
                                                    <button
                                                        className="btn btn-primary"
                                                        type="button"
                                                        onClick={handleSaveSettings}
                                                        disabled={isSavingSettings}
                                                    >
                                                        {isSavingSettings ? (
                                                            <Fragment>
                                                                <span className="spinner-border m-0 me-2" />
                                                                <span>{`Saving...`}</span>
                                                            </Fragment>
                                                        ) : (
                                                            <span>Save</span>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                )}

                                {tab.slug === "images" && (
                                    <div className="row m-0 align-items-start h-100">
                                        <div className="col-6 border-end p-3 align-self-stretch">
                                            <div className="row mb-3">
                                                <div className="col-6">
                                                    <label htmlFor="seoSprintAIQuality" className="form-label">
                                                        Quality:
                                                    </label>
                                                    <AIImageQulaitySelector
                                                        selectName="seoSprintAIQuality"
                                                        value={imageQuality || ""}
                                                        onSelect={(e) => setImageQuality(e.target.value)}
                                                        disabled={
                                                            isSavingSelectedImages ||
                                                            isSavingImageSettings ||
                                                            isGettingImages ||
                                                            isCreatingImagesCsv
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <label htmlFor="numberOfImages" className="form-label">
                                                        Number Of Images:
                                                    </label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="numberOfImages"
                                                        value={numberOfImages || ""}
                                                        onChange={(e) => setNumberOfImages(e.target.value)}
                                                        min={1}
                                                        max={20}
                                                        disabled={
                                                            isSavingSelectedImages ||
                                                            isSavingImageSettings ||
                                                            isGettingImages ||
                                                            isCreatingImagesCsv
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-1">
                                                <div className="col-12">
                                                    <label htmlFor="seoSprintSeedImagesSubjects" className="form-label w-100">
                                                        <div>
                                                            <span>Subjects:</span>
                                                            <button
                                                                className="btn btn-link p-0 ms-4 align-baseline"
                                                                disabled={
                                                                    isSavingSelectedImages ||
                                                                    isSavingImageSettings ||
                                                                    isGettingImages ||
                                                                    isCreatingImagesCsv
                                                                }
                                                                onClick={getImagesSubjects}
                                                            >
                                                                {isGettingImagesSubjects ? (
                                                                    <Fragment>
                                                                        <span className="spinner-border m-0 me-2" />
                                                                        <span>Getting Subjects...</span>
                                                                    </Fragment>
                                                                ) : (
                                                                    <span>Get Subjects</span>
                                                                )}
                                                            </button>
                                                            <button
                                                                className="btn btn-link p-0 ms-4 align-baseline float-end"
                                                                onClick={() =>
                                                                    setIsEditingImagesSubjectsCommand(!isEditingImagesSubjectsCommand)
                                                                }
                                                                disabled={
                                                                    isSavingSelectedImages ||
                                                                    isSavingImageSettings ||
                                                                    isGettingImages ||
                                                                    isCreatingImagesCsv
                                                                }
                                                            >
                                                                {isEditingImagesSubjectsCommand ? "Cancel" : "Edit Subjects Command"}
                                                            </button>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className={isEditingImagesSubjectsCommand ? "col-6" : "col-12"}>
                                                    <textarea
                                                        className="form-control"
                                                        name="seoSprintSeedImagesSubjects"
                                                        value={seedImagesSubjects || ""}
                                                        onChange={(e) => setSeedImagesSubjects(e.target.value)}
                                                        rows={5}
                                                        disabled={
                                                            isSavingSelectedImages ||
                                                            isSavingImageSettings ||
                                                            isGettingImages ||
                                                            isCreatingImagesCsv
                                                        }
                                                    />
                                                </div>
                                                {isEditingImagesSubjectsCommand && (
                                                    <div className={"col-6"}>
                                                        <textarea
                                                            className="form-control"
                                                            name="imagesSubjectsCommand"
                                                            value={imagesSubjectsCommand || ""}
                                                            onChange={(e) => setImagesSubjectsCommand(e.target.value)}
                                                            rows={5}
                                                            disabled={
                                                                isSavingSelectedImages ||
                                                                isSavingImageSettings ||
                                                                isGettingImages ||
                                                                isCreatingImagesCsv
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-6">
                                                    <label htmlFor="seedImagesInclusions" className="form-label">
                                                        Inclusions:
                                                    </label>
                                                    <textarea
                                                        className="form-control"
                                                        name="seedImagesInclusions"
                                                        value={seedImagesInclusions || ""}
                                                        onChange={(e) => setSeedImagesInclusions(e.target.value)}
                                                        rows={5}
                                                        disabled={
                                                            isSavingSelectedImages ||
                                                            isSavingImageSettings ||
                                                            isGettingImages ||
                                                            isCreatingImagesCsv
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <label htmlFor="seedImagesExclusions" className="form-label">
                                                        Exclusions:
                                                    </label>
                                                    <textarea
                                                        className="form-control"
                                                        name="seedImagesExclusions"
                                                        value={seedImagesExclusions || ""}
                                                        onChange={(e) => setSeedImagesExclusions(e.target.value)}
                                                        rows={5}
                                                        disabled={
                                                            isSavingSelectedImages ||
                                                            isSavingImageSettings ||
                                                            isGettingImages ||
                                                            isCreatingImagesCsv
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <label htmlFor="seoSprintSeedImagesCommand" className="form-label">
                                                        Command:
                                                    </label>
                                                    <textarea
                                                        className="form-control"
                                                        name="seoSprintSeedImagesCommand"
                                                        value={seedImagesCommand || ""}
                                                        onChange={(e) => setSeedImagesCommand(e.target.value)}
                                                        rows={5}
                                                        disabled={
                                                            isSavingSelectedImages ||
                                                            isSavingImageSettings ||
                                                            isGettingImages ||
                                                            isCreatingImagesCsv
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <button
                                                        className="btn btn-primary"
                                                        type="button"
                                                        onClick={getImagesByPrompt}
                                                        disabled={
                                                            isSavingSelectedImages ||
                                                            isSavingImageSettings ||
                                                            isGettingImages ||
                                                            isCreatingImagesCsv
                                                        }
                                                    >
                                                        {isGettingImages ? (
                                                            <Fragment>
                                                                <span className="spinner-border m-0 me-2" />
                                                                <span>Getting images...</span>
                                                            </Fragment>
                                                        ) : (
                                                            <span>Get Images</span>
                                                        )}
                                                    </button>
                                                    <button
                                                        className="btn btn-primary ms-2"
                                                        type="button"
                                                        onClick={saveImagesData}
                                                        disabled={
                                                            isSavingSelectedImages ||
                                                            isSavingImageSettings ||
                                                            isGettingImages ||
                                                            isCreatingImagesCsv
                                                        }
                                                    >
                                                        {isSavingImageSettings ? (
                                                            <Fragment>
                                                                <span className="spinner-border m-0 me-2" />
                                                                <span>Saving...</span>
                                                            </Fragment>
                                                        ) : (
                                                            <span>Save Settings</span>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="row mb-3 align-items-start">
                                                <div className="col-8">
                                                    <label className="form-label">Response:</label>
                                                    <div className="images-response-wrapper">
                                                        {imageResponse && imageResponse.length > 0 && (
                                                            <Fragment>
                                                                {imageResponse.map((image, index) => {
                                                                    let imgIsSelected = false;
                                                                    if (selectedImages && selectedImages.length) {
                                                                        imgIsSelected = selectedImages.some((x) => x.id === image.id);
                                                                    }

                                                                    return (
                                                                        <div className="image-wrapper" key={index}>
                                                                            <img
                                                                                id={`img_${image.id}`}
                                                                                src={image.data}
                                                                                onClick={(e) => toggleImagePreviewDialog(e, image.data)}
                                                                                title="Preview Image"
                                                                            />
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id={`chkImg_${image.id}`}
                                                                                name={`chkImg_${image.id}`}
                                                                                checked={imgIsSelected}
                                                                                onChange={(e) => handleSelectImage(e)}
                                                                            />
                                                                        </div>
                                                                    );
                                                                })}
                                                            </Fragment>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-4">
                                                    {seedImagesData &&
                                                        seedImagesData.groups &&
                                                        seedImagesData.groups.length &&
                                                        imageResponse &&
                                                        imageResponse.length > 0 && (
                                                            <Fragment>
                                                                <label htmlFor="selectedImageGroup" className="form-label">
                                                                    Image Group:
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    name="selectedImageGroup"
                                                                    value={selectedImageGroup}
                                                                    onChange={(e) => setSelectedImageGroup(e.target.value)}
                                                                    required
                                                                    disabled={
                                                                        isSavingSelectedImages ||
                                                                        isSavingImageSettings ||
                                                                        isGettingImages ||
                                                                        isCreatingImagesCsv
                                                                    }
                                                                >
                                                                    {seedImagesData.groups.map((group, index) => {
                                                                        return (
                                                                            <option value={group.id} key={group.id}>
                                                                                {group.name}
                                                                            </option>
                                                                        );
                                                                    })}
                                                                </select>
                                                            </Fragment>
                                                        )}
                                                </div>
                                            </div>

                                            {imageResponse && imageResponse.length > 0 && (
                                                <div className="row mb-3">
                                                    <div className="col-12">
                                                        <button
                                                            className="btn btn-primary"
                                                            type="button"
                                                            onClick={() => saveSelectedImages()}
                                                            disabled={
                                                                isSavingSelectedImages ||
                                                                isSavingImageSettings ||
                                                                isGettingImages ||
                                                                isCreatingImagesCsv
                                                            }
                                                        >
                                                            {isSavingSelectedImages ? (
                                                                <Fragment>
                                                                    <span className="spinner-border m-0 me-2" />
                                                                    <span>Saving...</span>
                                                                </Fragment>
                                                            ) : (
                                                                <span>Save Selected Images</span>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-3 border-end p-3 align-self-stretch">
                                            <div className="seed-image-groups">
                                                <h6 className="mb-2">Image Groups:</h6>
                                                <div className="table-wrapper w-100">
                                                    <table className="table items-list border mb-2">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" className="group">
                                                                    <span>Name</span>
                                                                </th>
                                                                <th scope="col" />
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {seedImagesData &&
                                                                seedImagesData.groups &&
                                                                seedImagesData.groups.map((group, index) => (
                                                                    <tr key={index}>
                                                                        <td className="seed-image-group">{group.name}</td>
                                                                        <td className="seed-image-group-action text-end">
                                                                            <button
                                                                                href="#"
                                                                                className="btn btn-link p-0"
                                                                                onClick={() => toggleSeedImageGroupDialog(group.id)}
                                                                                title="Edit Group"
                                                                            >
                                                                                <i className="fa-solid fa-pen" />
                                                                            </button>
                                                                            <button
                                                                                href="#"
                                                                                className="btn btn-link p-0 ms-2"
                                                                                onClick={() => deleteSeedImageGroup(group.id)}
                                                                                title="Remove Group"
                                                                            >
                                                                                <i className="fa-solid fa-trash-can" />
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={() => toggleSeedImageGroupDialog()}
                                                    disabled={
                                                        isSavingSelectedImages ||
                                                        isSavingImageSettings ||
                                                        isGettingImages ||
                                                        isCreatingImagesCsv
                                                    }
                                                >
                                                    <span>Add New Group</span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="col-3 p-3">
                                            <h6 className="mb-2">Images:</h6>
                                            {seedImagesData && seedImagesData.images && seedImagesData.images.length > 0 && (
                                                <Fragment>
                                                    <div className="seo-sprint-images-list">
                                                        {seedImagesData.images.map((image, index) => {
                                                            return (
                                                                <div className="image-item" key={index}>
                                                                    <img
                                                                        src={image.url}
                                                                        onClick={(e) => toggleImagePreviewDialog(e, image.url)}
                                                                        title="Preview Image"
                                                                    />
                                                                    <button
                                                                        href="#"
                                                                        className="btn btn-link p-0 delete-btn"
                                                                        onClick={(e) => deleteSeedImage(e, image.url)}
                                                                        title="Delete Image"
                                                                    >
                                                                        <i className="fa-solid fa-times me-0" />
                                                                    </button>
                                                                    {image.groups && image.groups.length > 0 && (
                                                                        <Fragment>
                                                                            {image.groups.map((groupId, index) => {
                                                                                let groupName = "";
                                                                                if (
                                                                                    seedImagesData &&
                                                                                    seedImagesData.groups &&
                                                                                    seedImagesData.groups.length > 0
                                                                                ) {
                                                                                    let existingGroup = seedImagesData.groups.find(
                                                                                        (x) => x.id === groupId
                                                                                    );
                                                                                    if (existingGroup) {
                                                                                        groupName = existingGroup.name;
                                                                                    }
                                                                                }
                                                                                return (
                                                                                    <span className="image-group-name" key={index}>
                                                                                        {groupName}
                                                                                    </span>
                                                                                );
                                                                            })}
                                                                        </Fragment>
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    <div className="mb-3">
                                                        <button
                                                            href="#"
                                                            className="btn btn-primary"
                                                            onClick={createImagesCsv}
                                                            disabled={
                                                                isSavingSelectedImages ||
                                                                isSavingImageSettings ||
                                                                isGettingImages ||
                                                                isCreatingImagesCsv
                                                            }
                                                        >
                                                            {isCreatingImagesCsv ? (
                                                                <Fragment>
                                                                    <span className="spinner-border m-0 me-2" />
                                                                    <span>Generating...</span>
                                                                </Fragment>
                                                            ) : (
                                                                <span>Generate CSV File</span>
                                                            )}
                                                        </button>
                                                    </div>

                                                    {csvFiles && csvFiles.length > 0 && !isCreatingImagesCsv && (
                                                        <Fragment>
                                                            <div className="row">
                                                                {csvFiles
                                                                    .filter((x) => x === "images.csv")
                                                                    .map((csvFilename, index) => {
                                                                        return (
                                                                            <div className="col-auto me-3" key={index}>
                                                                                <a
                                                                                    className="btn btn-link p-0"
                                                                                    href={`https://${apiUrl}/uploads/${campaignId}/seosprint/${csvFilename}`}
                                                                                    disabled={
                                                                                        isSavingSelectedImages ||
                                                                                        isSavingImageSettings ||
                                                                                        isGettingImages ||
                                                                                        isCreatingImagesCsv
                                                                                    }
                                                                                >
                                                                                    {csvFilename}
                                                                                </a>
                                                                            </div>
                                                                        );
                                                                    })}
                                                            </div>
                                                        </Fragment>
                                                    )}
                                                </Fragment>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {tab.slug === "onSiteContent" && (
                                    <div className="p-3">
                                        <div className="row mb-3">
                                            <div className="col-6">
                                                <button
                                                    className="btn btn-primary"
                                                    type="button"
                                                    onClick={handleGenerateContentCsvFiles}
                                                    disabled={isCreatingContentCsv || isSavingSettings || isUploadingContentOnWPSite}
                                                >
                                                    {isCreatingContentCsv ? (
                                                        <Fragment>
                                                            <span className="spinner-border m-0 me-2" />
                                                            <span>{`Generating CSV Files...`}</span>
                                                        </Fragment>
                                                    ) : (
                                                        <span>Generate CSV Files</span>
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        {csvFiles && csvFiles.length > 0 && (
                                            <Fragment>
                                                <div className="row mb-4">
                                                    {csvFiles
                                                        .filter(
                                                            (x) =>
                                                                x === "services.csv" || x === "locations.csv" || x === "OnSiteContent.zip"
                                                        )
                                                        .map((csvFilename, index) => {
                                                            return (
                                                                <div className="col-auto me-3" key={index}>
                                                                    <a
                                                                        className="btn btn-link p-0"
                                                                        href={`https://${apiUrl}/uploads/${campaignId}/seosprint/${csvFilename}`}
                                                                        disabled={isCreatingContentCsv}
                                                                    >
                                                                        {csvFilename}
                                                                    </a>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </Fragment>
                                        )}

                                        <div className="row mb-3">
                                            <label htmlFor="seoSprintPrimaryServices" className="form-label col-2">
                                                WordPress Site Url:
                                            </label>
                                            <div className="col-4">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="seoSprintWPSiteUrl"
                                                    value={formData.seoSprintWPSiteUrl || ""}
                                                    onChange={handleChange}
                                                    disabled={isSavingSettings}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-4">
                                                <button
                                                    className="btn btn-primary"
                                                    type="button"
                                                    onClick={saveCampaignWPSiteUrl}
                                                    disabled={isCreatingContentCsv || isSavingSettings || isUploadingContentOnWPSite}
                                                >
                                                    {isSavingSettings ? (
                                                        <Fragment>
                                                            <span className="spinner-border m-0 me-2" />
                                                            <span>Saving...</span>
                                                        </Fragment>
                                                    ) : (
                                                        <span>Save</span>
                                                    )}
                                                </button>
                                                <button
                                                    className="btn btn-primary ms-2"
                                                    type="button"
                                                    onClick={uploadContentOnWPSite}
                                                    disabled={isCreatingContentCsv || isSavingSettings || isUploadingContentOnWPSite}
                                                >
                                                    {isUploadingContentOnWPSite ? (
                                                        <Fragment>
                                                            <span className="spinner-border m-0 me-2" />
                                                            <span>Uploading...</span>
                                                        </Fragment>
                                                    ) : (
                                                        <span>Upload Content On WordPress Site</span>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {tab.slug === "gbpPosts" && (
                                    <div className="p-3">
                                        <div className="row align-items-start">
                                            <div className="col-4">
                                                {campaign && (
                                                    <GbpPostingForm
                                                        campaignData={campaign}
                                                        isCreatingGbpCsv={isCreatingGbpCsv}
                                                        validateSettingsRequiredFields={validateSettingsRequiredFields}
                                                        onSubmit={() => {
                                                            getCSVFiles();
                                                            getSeoSprintHistoryList();
                                                        }}
                                                    ></GbpPostingForm>
                                                )}

                                                {csvFiles && csvFiles.length > 0 && (
                                                    <Fragment>
                                                        <div className="row">
                                                            {csvFiles
                                                                .filter((x) => x === "gbp_posts.csv")
                                                                .map((csvFilename, index) => {
                                                                    return (
                                                                        <div className="col-auto me-3" key={index}>
                                                                            <a
                                                                                className="btn btn-link p-0"
                                                                                href={`https://${apiUrl}/uploads/${campaignId}/seosprint/${csvFilename}`}
                                                                                disabled={isCreatingGbpCsv}
                                                                            >
                                                                                {csvFilename}
                                                                            </a>
                                                                        </div>
                                                                    );
                                                                })}
                                                        </div>
                                                    </Fragment>
                                                )}
                                            </div>
                                            <div className="col-8">
                                                <div className="table-wrapper border">
                                                    <table className="items-list campaigns-list seo-sprint-history-list table table-responsive">
                                                        <thead>
                                                            <tr>
                                                                <th className="date" scope="col">
                                                                    Date Created
                                                                </th>
                                                                <th className="count" scope="col">
                                                                    Is Posted
                                                                </th>
                                                                <th className="date-time" scope="col">
                                                                    First Post Date
                                                                </th>
                                                                <th className="date-time" scope="col">
                                                                    Last Post Date
                                                                </th>
                                                                <th className="count" scope="col">
                                                                    Total Posts
                                                                </th>
                                                                <th className="count" scope="col">
                                                                    Posts Per week
                                                                </th>
                                                                <th className="count" scope="col">
                                                                    Weekends
                                                                </th>
                                                                <th scope="col" />
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {seoSprintHistoryList && seoSprintHistoryList.length > 0 && (
                                                                <Fragment>
                                                                    {seoSprintHistoryList.map((item, index) => (
                                                                        <tr key={item.id}>
                                                                            <td className="date">
                                                                                <Moment format="MM/DD/YYYY">{item.dateCreated}</Moment>
                                                                            </td>
                                                                            <td className="count">
                                                                                {item.status === "Posted" ? "Yes" : "No"}
                                                                            </td>
                                                                            <td className="date-time">
                                                                                {item.firstPostDate ? (
                                                                                    <Moment format="MM/DD/YYYY hh:mm A">
                                                                                        {item.firstPostDate}
                                                                                    </Moment>
                                                                                ) : (
                                                                                    ""
                                                                                )}
                                                                            </td>
                                                                            <td className="date-time">
                                                                                {item.lastPostDate ? (
                                                                                    <Moment format="MM/DD/YYYY hh:mm A">
                                                                                        {item.lastPostDate}
                                                                                    </Moment>
                                                                                ) : (
                                                                                    ""
                                                                                )}
                                                                            </td>
                                                                            <td className="status">{item.totalPosts}</td>
                                                                            <td className="status">{item.postsPerWeek}</td>
                                                                            <td className="count">{item.excludeWeekends ? "No" : "Yes"}</td>
                                                                            <td className="task-action text-end">
                                                                                <a
                                                                                    target="_blank"
                                                                                    className="btn btn-link py-0"
                                                                                    href={`https://${apiUrl}${item.link}`}
                                                                                    title="Preview"
                                                                                >
                                                                                    <i className="fa-solid fa-up-right-from-square" />
                                                                                </a>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </Fragment>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {tab.slug === "facebookPosts" && (
                                    <div className="p-3">
                                        <div className="row mb-3 align-items-start">
                                            {campaign && campaign.seoSprintListOfServices && (
                                                <div className="col-5 pe-4">
                                                    <div className="table-wrapper">
                                                        <table className="table items-list border mb-2">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col" />
                                                                    <th scope="col">
                                                                        <span>Service</span>
                                                                    </th>
                                                                    <th scope="col">
                                                                        <span>Image</span>
                                                                    </th>
                                                                    <th scope="col" />
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {campaign.seoSprintListOfServices.split("\n").map((service, index) => {
                                                                    let serviceSlug = service.replaceAll(" ", "_");

                                                                    let imageUrl, imageName;
                                                                    if (facebookServicesData && facebookServicesData.length) {
                                                                        let foundService = facebookServicesData.find(
                                                                            (x) => x.service === service
                                                                        );
                                                                        if (foundService) {
                                                                            imageUrl = foundService.imageUrl;

                                                                            imageName = imageUrl.split("/").pop();
                                                                        }
                                                                    }

                                                                    return (
                                                                        <tr key={index}>
                                                                            <td className="checkbox-input">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input"
                                                                                    name={`chkService_${serviceSlug}`}
                                                                                    id={`chkService_${serviceSlug}`}
                                                                                    data-service={service}
                                                                                    onChange={handleFacebookSelectedServiceChange}
                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                <span>{service}</span>
                                                                            </td>
                                                                            <td>
                                                                                {imageUrl ? (
                                                                                    <button
                                                                                        className="btn btn-link p-0"
                                                                                        onClick={(e) =>
                                                                                            toggleImagePreviewDialog(e, imageUrl)
                                                                                        }
                                                                                    >
                                                                                        {imageName}
                                                                                    </button>
                                                                                ) : (
                                                                                    <Fragment />
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                <FileUpload
                                                                                    onFileChange={handleFacebookImageUpload}
                                                                                    imageType="facebook"
                                                                                    keywordId={service}
                                                                                    isUploading={isUploadingFiles}
                                                                                    isLinkButton={true}
                                                                                />
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-link p-0 ms-3"
                                                                                    onClick={(e) => toggleSelectImageDialog(service)}
                                                                                >
                                                                                    Select
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="col-3">
                                                <div className="row mb-3">
                                                    <label htmlFor="facebookScheduleDate" className="form-label col-5">
                                                        Schedule Date:
                                                    </label>
                                                    <div className="col-7">
                                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                                            <DateTimePicker
                                                                name="facebookScheduleDate"
                                                                className="form-control"
                                                                value={facebookScheduleDate || ""}
                                                                //inputFormat="HH:mm"
                                                                timezone="America/New_York"
                                                                onChange={(newValue) => setFacebookScheduleDate(newValue)}
                                                                disabled={isCreatingFacebookCsv}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="facebookExcludeWeekends" className="form-label col-5">
                                                        Exclude Weekends:
                                                    </label>
                                                    <div className="col-7">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            name="facebookExcludeWeekends"
                                                            id="facebookExcludeWeekends"
                                                            checked={facebookExcludeWeekends}
                                                            onChange={(e) => setFacebookExcludeWeekends(e.target.checked)}
                                                            disabled={isCreatingFacebookCsv}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-6">
                                                <button
                                                    className="btn btn-primary"
                                                    type="button"
                                                    onClick={handleGenerateFacebookPostsCsvFiles}
                                                    disabled={isCreatingFacebookCsv}
                                                >
                                                    {isCreatingFacebookCsv ? (
                                                        <Fragment>
                                                            <span className="spinner-border m-0 me-2" />
                                                            <span>{`Generating CSV File...`}</span>
                                                        </Fragment>
                                                    ) : (
                                                        <span>Generate CSV File</span>
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        {csvFiles && csvFiles.length > 0 && (
                                            <Fragment>
                                                <div className="row">
                                                    {csvFiles
                                                        .filter((x) => x.includes("facebook_posts"))
                                                        .map((csvFilename, index) => {
                                                            return (
                                                                <div className="col-auto me-3" key={index}>
                                                                    <a
                                                                        className="btn btn-link p-0"
                                                                        href={`https://${apiUrl}/uploads/${campaignId}/seosprint/${csvFilename}`}
                                                                        disabled={isCreatingFacebookCsv}
                                                                    >
                                                                        {csvFilename}
                                                                    </a>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </Fragment>
                                        )}
                                    </div>
                                )}

                                {tab.slug === "generateVideos" && (
                                    <div className="p-3">
                                        <div className="row mb-3 align-items-start">
                                            <div className="col-auto">
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="searchVideosType"
                                                        id="searchVideosTypeLocations"
                                                        value="locations"
                                                        onChange={(e) => setVideosType(e.target.value)}
                                                        checked={videosType === "locations"}
                                                    />
                                                    <label className="form-check-label w-auto" htmlFor="searchVideosTypeLocations">
                                                        Locations
                                                    </label>
                                                </div>
                                                <div className="form-check form-check-inline ms-5">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="searchVideosType"
                                                        id="searchVideosTypeServices"
                                                        value="services"
                                                        onChange={(e) => setVideosType(e.target.value)}
                                                        checked={videosType === "services"}
                                                    />
                                                    <label className="form-check-label" htmlFor="searchVideosTypeServices">
                                                        Services
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {videosType === "locations" && (
                                            <div className="row mb-3 align-items-start">
                                                <div className="col-auto pe-5">
                                                    <label className="form-label">
                                                        <span>Locations:</span>
                                                        <span className="ms-3">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                name="chkAllLocations"
                                                                id="chkAllLocations"
                                                                onChange={handleSelectAllVideosLocationsChange}
                                                                disabled={isCreatingVideosCsv}
                                                            />
                                                            <label htmlFor="chkAllLocations" className="form-check-label w-auto ms-1">
                                                                All
                                                            </label>
                                                        </span>
                                                    </label>
                                                    <div className="locations-wrapper">
                                                        {formData.seoSprintListOfLocations && (
                                                            <Fragment>
                                                                {formData.seoSprintListOfLocations
                                                                    .split("\n")
                                                                    .map((location, locationIndex) => {
                                                                        let isLocationSelected =
                                                                            videosLocations && videosLocations.includes(location);

                                                                        return (
                                                                            <div className="form-check" key={locationIndex}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input"
                                                                                    name={`chkLocation_${locationIndex}`}
                                                                                    id={`chkLocation_${locationIndex}`}
                                                                                    value={location}
                                                                                    onChange={handleVideosLocationsChange}
                                                                                    checked={isLocationSelected}
                                                                                    disabled={isCreatingVideosCsv}
                                                                                />
                                                                                <label
                                                                                    htmlFor={`chkLocation_${locationIndex}`}
                                                                                    className="form-check-label w-auto me-2"
                                                                                >
                                                                                    {location}
                                                                                </label>
                                                                            </div>
                                                                        );
                                                                    })}
                                                            </Fragment>
                                                        )}
                                                    </div>
                                                    <label className="form-label mt-0">{`${
                                                        videosLocations ? videosLocations.length : 0
                                                    }/${totalLocationsCount} locations selected`}</label>
                                                </div>

                                                <div className="col-auto pe-5">
                                                    <label className="form-label">
                                                        <span>Image Groups:</span>
                                                        <span className="ms-3">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                name="chkAllImageGroups"
                                                                id="chkAllImageGroups"
                                                                onChange={handleSelectAllVideosImageGroupsChange}
                                                                disabled={isCreatingVideosCsv}
                                                            />
                                                            <label htmlFor="chkAllImageGroups" className="form-check-label w-auto ms-1">
                                                                All
                                                            </label>
                                                        </span>
                                                    </label>
                                                    <div className="locations-wrapper">
                                                        {seedImagesData && seedImagesData.groups && (
                                                            <Fragment>
                                                                {seedImagesData.groups.map((group, locationsGroupIndex) => {
                                                                    let imagesCount = getImagesNumberByGroup(group.id);
                                                                    let isGroupSelected =
                                                                        selectedImageGroupsForVideos &&
                                                                        selectedImageGroupsForVideos.includes(group.id);
                                                                    return (
                                                                        <div className="form-check" key={locationsGroupIndex}>
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                name={`chkSeedImageGroup_${group.id}`}
                                                                                id={`chkSeedImageGroup_${group.id}`}
                                                                                onChange={handleSelectedImageGroupsForVideosChange}
                                                                                checked={isGroupSelected}
                                                                                disabled={isCreatingVideosCsv}
                                                                            />
                                                                            <label
                                                                                htmlFor={`chkSeedImageGroup_${group.id}`}
                                                                                className="form-check-label w-auto me-2"
                                                                            >
                                                                                {`${group.name}${imagesCount ? ` (${imagesCount})` : ""}`}
                                                                            </label>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </Fragment>
                                                        )}
                                                    </div>
                                                    <label className="form-label mt-0">{`${totalImagesCountForSelectedGroups} images selected`}</label>
                                                </div>
                                            </div>
                                        )}

                                        {videosType === "services" && (
                                            <div className="row mb-3 align-items-start">
                                                {campaign && campaign.seoSprintListOfServices && (
                                                    <div className="col-5 pe-4">
                                                        <table className="table items-list border mb-2">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">
                                                                        <span>Service</span>
                                                                    </th>
                                                                    <th scope="col">
                                                                        <span>Image Groups</span>
                                                                    </th>
                                                                    <th scope="col" />
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {campaign.seoSprintListOfServices
                                                                    .split("\n")
                                                                    .map((service, serviceIndex) => {
                                                                        let serviceSlug = service.replaceAll(" ", "_");
                                                                        let isServiceSelected = false;
                                                                        if (videosServicesData) {
                                                                            let currentService = videosServicesData.find(
                                                                                (x) => x.service === service
                                                                            );
                                                                            isServiceSelected = currentService && currentService.checked;
                                                                        }

                                                                        return (
                                                                            <tr key={serviceIndex}>
                                                                                <td>
                                                                                    <div className="form-check">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="form-check-input"
                                                                                            name={`chkVideoService_${serviceSlug}`}
                                                                                            id={`chkVideoService_${serviceSlug}`}
                                                                                            data-service={service}
                                                                                            onChange={handleVideosSelectedServiceChange}
                                                                                            checked={isServiceSelected}
                                                                                            disabled={isCreatingVideosCsv}
                                                                                        />
                                                                                        <label
                                                                                            htmlFor={`chkVideoService_${serviceSlug}`}
                                                                                            className="form-check-label w-auto ms-3"
                                                                                        >
                                                                                            {service}
                                                                                        </label>
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <div className="services-list-wrapper">
                                                                                        {seedImagesData && seedImagesData.groups && (
                                                                                            <Fragment>
                                                                                                {seedImagesData.groups.map(
                                                                                                    (group, groupIndex) => {
                                                                                                        let imagesCount =
                                                                                                            getImagesNumberByGroup(
                                                                                                                group.id
                                                                                                            );
                                                                                                        let isGroupSelected = false;
                                                                                                        if (
                                                                                                            videosServicesData &&
                                                                                                            videosServicesData.length
                                                                                                        ) {
                                                                                                            let currentService =
                                                                                                                videosServicesData.find(
                                                                                                                    (x) =>
                                                                                                                        x.service ===
                                                                                                                        service
                                                                                                                );
                                                                                                            if (
                                                                                                                currentService &&
                                                                                                                currentService.imageGroups &&
                                                                                                                currentService.imageGroups.includes(
                                                                                                                    group.id
                                                                                                                )
                                                                                                            ) {
                                                                                                                isGroupSelected = true;
                                                                                                            }
                                                                                                        }

                                                                                                        return (
                                                                                                            <Fragment
                                                                                                                key={`${serviceIndex}_${group.id}`}
                                                                                                            >
                                                                                                                {imagesCount &&
                                                                                                                imagesCount > 0 ? (
                                                                                                                    <div className="form-check">
                                                                                                                        <input
                                                                                                                            type="checkbox"
                                                                                                                            className="form-check-input"
                                                                                                                            name={`chkVideosServiceImageGroup_${group.id}_${serviceSlug}`}
                                                                                                                            id={`chkVideosServiceImageGroup_${group.id}_${serviceSlug}`}
                                                                                                                            onChange={(e) =>
                                                                                                                                handleSelectedImageGroupsForVideosServiceChange(
                                                                                                                                    e,
                                                                                                                                    service
                                                                                                                                )
                                                                                                                            }
                                                                                                                            checked={
                                                                                                                                isGroupSelected
                                                                                                                            }
                                                                                                                            disabled={
                                                                                                                                isCreatingVideosCsv
                                                                                                                            }
                                                                                                                        />
                                                                                                                        <label
                                                                                                                            htmlFor={`chkVideosServiceImageGroup_${group.id}_${serviceSlug}`}
                                                                                                                            className="form-check-label w-auto me-2"
                                                                                                                        >
                                                                                                                            {group.name}
                                                                                                                        </label>
                                                                                                                    </div>
                                                                                                                ) : (
                                                                                                                    <Fragment />
                                                                                                                )}
                                                                                                            </Fragment>
                                                                                                        );
                                                                                                    }
                                                                                                )}
                                                                                            </Fragment>
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                                <td />
                                                                            </tr>
                                                                        );
                                                                    })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <div className="row mb-3">
                                            <div className="col-6">
                                                <button
                                                    className="btn btn-primary"
                                                    type="button"
                                                    onClick={handleGenerateVideosCsvFiles}
                                                    disabled={isCreatingVideosCsv}
                                                >
                                                    {isCreatingVideosCsv ? (
                                                        <Fragment>
                                                            <span className="spinner-border m-0 me-2" />
                                                            <span>{`Generating CSV File...`}</span>
                                                        </Fragment>
                                                    ) : (
                                                        <span>Generate CSV File</span>
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        {csvFiles && csvFiles.length > 0 && (
                                            <div className="row">
                                                {csvFiles
                                                    .filter((x) => x === "videos_locations.csv" || x === "videos_services.csv")
                                                    .map((csvFilename, index) => {
                                                        return (
                                                            <div className="col-auto me-3" key={index}>
                                                                <a
                                                                    className="btn btn-link p-0"
                                                                    href={`https://${apiUrl}/uploads/${campaignId}/seosprint/${csvFilename}`}
                                                                    disabled={isCreatingVideosCsv}
                                                                >
                                                                    {csvFilename}
                                                                </a>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        )}
                                    </div>
                                )}

                                {tab.slug === "youTubeVideos" && (
                                    <div className="p-3">
                                        <div className="row mb-3 align-items-start">
                                            <div className="row mb-3">
                                                <label className="form-label col-2">Upload Files:</label>
                                                <div className="col-4">
                                                    <div className="mb-1">
                                                        <FileUpload
                                                            onFileChange={handleYouTubeVideosUpload}
                                                            imageType="videos"
                                                            isUploading={isUploadingFiles}
                                                        />
                                                    </div>

                                                    {csvFiles && csvFiles.length > 0 && (
                                                        <Fragment>
                                                            <div className="row">
                                                                {csvFiles
                                                                    .filter((x) => x.includes("youtube/"))
                                                                    .map((csvFilename, index) => {
                                                                        let csvShortName = csvFilename.replace("youtube/", "");
                                                                        return (
                                                                            <div className="col-auto me-3" key={index}>
                                                                                <a
                                                                                    className="btn btn-link p-0"
                                                                                    href={`https://${apiUrl}/uploads/${campaignId}/seosprint/${csvFilename}`}
                                                                                    disabled={isCreatingYouTubeCsv}
                                                                                >
                                                                                    {csvShortName}
                                                                                </a>
                                                                            </div>
                                                                        );
                                                                    })}

                                                                {csvFiles.filter((x) => x.includes("youtube/")).length > 0 && (
                                                                    <div className="col-auto me-3">
                                                                        <button
                                                                            className="btn btn-link p-0"
                                                                            type="button"
                                                                            onClick={handleDeleteYouTubeVideosFiles}
                                                                            disabled={isDeletingYouTubeCsv}
                                                                        >
                                                                            {isDeletingYouTubeCsv ? (
                                                                                <Fragment>
                                                                                    <span className="spinner-border m-0 me-2" />
                                                                                    <span>{`deleting...`}</span>
                                                                                </Fragment>
                                                                            ) : (
                                                                                <span>
                                                                                    <i
                                                                                        className="fa-solid fa-trash-can text-danger"
                                                                                        title="Delete Files"
                                                                                    />
                                                                                </span>
                                                                            )}
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </Fragment>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <label htmlFor="youTubePostsPerDay" className="form-label col-2">
                                                    Posts Per Day:
                                                </label>
                                                <div className="col-4">
                                                    <input
                                                        type="number"
                                                        className="form-control w-auto"
                                                        name="youTubePostsPerDay"
                                                        value={youTubePostsPerDay || ""}
                                                        onChange={(e) => setYouTubePostsPerDay(e.target.value)}
                                                        min={1}
                                                        max={10}
                                                        required
                                                        disabled={isCreatingYouTubeCsv}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row mb-2">
                                                <label htmlFor="youTubeSchedulingOn" className="form-label col-2">
                                                    Use Scheduling:
                                                </label>
                                                <div className="col-4">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        name="youTubeSchedulingOn"
                                                        id="youTubeSchedulingOn"
                                                        checked={youTubeSchedulingOn}
                                                        onChange={(e) => {
                                                            let checked = e.target.checked;
                                                            setYouTubeSchedulingOn(checked);
                                                        }}
                                                        disabled={isCreatingYouTubeCsv}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <label htmlFor="youTubeScheduleDate" className="form-label col-2">
                                                    Schedule Date:
                                                </label>
                                                <div className="col-4">
                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                        <DateTimePicker
                                                            name="youTubeScheduleDate"
                                                            className="form-control w-auto"
                                                            value={youTubeScheduleDate || ""}
                                                            //inputFormat="HH:mm"
                                                            timezone="America/New_York"
                                                            onChange={(newValue) => setYouTubeScheduleDate(newValue)}
                                                            disabled={isCreatingYouTubeCsv || !youTubeSchedulingOn}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <label htmlFor="youTubeExcludeWeekends" className="form-label col-2">
                                                    Exclude Weekends:
                                                </label>
                                                <div className="col-4">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        name="youTubeExcludeWeekends"
                                                        id="youTubeExcludeWeekends"
                                                        checked={youTubeExcludeWeekends}
                                                        onChange={(e) => setYouTubeExcludeWeekends(e.target.checked)}
                                                        disabled={isCreatingYouTubeCsv || !youTubeSchedulingOn}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-6">
                                                <button
                                                    className="btn btn-primary"
                                                    type="button"
                                                    onClick={handleGenerateYouTubeVideosCsvFiles}
                                                    disabled={isCreatingYouTubeCsv}
                                                >
                                                    {isCreatingYouTubeCsv ? (
                                                        <Fragment>
                                                            <span className="spinner-border m-0 me-2" />
                                                            <span>{`Generating CSV File...`}</span>
                                                        </Fragment>
                                                    ) : (
                                                        <span>Generate CSV File</span>
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        {csvFiles && csvFiles.length > 0 && (
                                            <Fragment>
                                                <div className="row">
                                                    {csvFiles
                                                        .filter((x) => x.includes("youtube_videos"))
                                                        .map((csvFilename, index) => {
                                                            return (
                                                                <div className="col-auto me-3" key={index}>
                                                                    <a
                                                                        className="btn btn-link p-0"
                                                                        href={`https://${apiUrl}/uploads/${campaignId}/seosprint/${csvFilename}`}
                                                                        disabled={isCreatingYouTubeCsv}
                                                                    >
                                                                        {csvFilename}
                                                                    </a>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </Fragment>
                                        )}
                                    </div>
                                )}

                                {tab.slug === "report" && (
                                    <div className="p-3">
                                        <div className="row mb-3">
                                            <div className="col-6">
                                                <button
                                                    className="btn btn-primary"
                                                    type="button"
                                                    onClick={handleGenerateReportCsvFiles}
                                                    disabled={isCreatingReportCsv}
                                                >
                                                    {isCreatingReportCsv ? (
                                                        <Fragment>
                                                            <span className="spinner-border m-0 me-2" />
                                                            <span>{`Generating CSV File...`}</span>
                                                        </Fragment>
                                                    ) : (
                                                        <span>Generate CSV File</span>
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        {csvFiles && csvFiles.length > 0 && (
                                            <Fragment>
                                                <div className="row">
                                                    {csvFiles
                                                        .filter((x) => x === "report.csv")
                                                        .map((csvFilename, index) => {
                                                            return (
                                                                <div className="col-auto me-3" key={index}>
                                                                    <a
                                                                        className="btn btn-link p-0"
                                                                        href={`https://${apiUrl}/uploads/${campaignId}/seosprint/${csvFilename}`}
                                                                        disabled={isCreatingGbpCsv}
                                                                    >
                                                                        {csvFilename}
                                                                    </a>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </Fragment>
                                        )}
                                    </div>
                                )}

                                {tab.slug === "placeholders" && (
                                    <div className="p-3">
                                        {placeholders.map((ph, index) => {
                                            return (
                                                <div className="row mb-1" key={index}>
                                                    <label className="form-label col-2">{`${ph.label}:`}</label>
                                                    <div className="col-4">
                                                        <label className="form-label">{ph.value}</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-0 text-body ms-2 align-baseline"
                                                            onClick={() => {
                                                                copyToClipboard(ph.value);
                                                                // setShowCopiedMessage(true);
                                                                // setInterval(function() {
                                                                // 	setShowCopiedMessage(false);
                                                                // }, 2000);
                                                            }}
                                                            title={`Copy ${ph.value} to clipboard`}
                                                        >
                                                            <span>
                                                                <i className="fa-regular fa-copy" />
                                                            </span>
                                                            {showCopiedMessage && <span>Copied!</span>}
                                                        </button>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        ))}

                        {showSelectImageDialog && (
                            <CampaignSEOSprintSelectImageDialog
                                imagesData={seedImagesData}
                                onImageSelect={handleSelectFacebookImage}
                                onClose={toggleSelectImageDialog}
                                arg={imageSelectDialogArg}
                            />
                        )}
                    </div>
                </div>
            )}

            <CampaignButtonsContainer
                campaign={campaign}
                showSaveButton={false}
                onSaveNext={() => handleNext()}
                saveNextButtonText="Next"
                disabled={
                    isSavingSettings ||
                    isCreatingContentCsv ||
                    isCreatingGbpCsv ||
                    isCreatingFacebookCsv ||
                    isCreatingVideosCsv ||
                    isCreatingYouTubeCsv ||
                    isCreatingImagesCsv
                }
            />

            {showSeedImageGroupDialog && (
                <ModalDialog position="right-sidebar">
                    <ModalDialogContent align="start">
                        <div className="col-12 mb-3">
                            <label htmlFor="seedImageGroupName" className="form-label">
                                Group Name:
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                name="seedImageGroupName"
                                value={seedImageGroupName || ""}
                                onChange={(e) => setSeedImageGroupName(e.target.value)}
                            />
                        </div>
                    </ModalDialogContent>
                    <ModalDialogButtons>
                        <Fragment>
                            <button className="btn btn-primary" type="button" onClick={() => saveSeedImageGroup()}>
                                <span>Save</span>
                            </button>
                            <button className="btn btn-outline-primary ms-2" type="button" onClick={() => toggleSeedImageGroupDialog()}>
                                Cancel
                            </button>
                        </Fragment>
                    </ModalDialogButtons>
                </ModalDialog>
            )}

            {showImagePreviewDialog && <ImagePreviewModal imageSrc={imagePreviewSrc} onClose={(e) => toggleImagePreviewDialog(e)} />}
        </div>
    );
};

export default CampaignSEOSprintScreen;
